import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";
import OneStaff from "./OneStaff";

import staff1 from "../assets/GM.jpg";
import staff2 from "../assets/AK.jpg";
import staff3 from "../assets/MM.jpg";
import staff4 from "../assets/DM.jpg";
import staff5 from "../assets/CK.jpg";

export default function Staff() {
  const appContext = useContext(AppContext);

  const staffMembers = [
    {
      passport: staff5,
      name: "Amb. Chabaka F. Kilumanga",
      position: "Chairman",
      intro: "Experienced diplomat and leader with extensive international relations expertise.",
    },
    {
      passport: staff1,
      name: "Mr. George R. Mziray",
      position: "Executive Director",
      intro: "Senior consultant with over 25 years of experience in Tanzania.",
    },
    {
      passport: staff2,
      name: "Mr. Aziz M. Kilonge",
      position: "Director Operations and Programmes",
      intro: "Procurement and management specialist with extensive operational experience.",
    },
    {
      passport: staff4,
      name: "Ms. Diana F. Mushi",
      position: "Social Expert",
      intro: "Community engagement specialist focused on social impact initiatives.",
    },
    {
      passport: staff3,
      name: "Adv. Ms. Mourine H. Msangi",
      position: "Legal Counsel",
      intro: "Founder and executive director of legal advocacy initiatives.",
    },
  ];

  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: false });
    AOS.refresh();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection bg-background" style={{ paddingBottom: "50px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="main-section-title">OUR STAFF</h6>
            <h6 className="text-dim pb-5 text-center">
              Meet the passionate team driving our mission forward. Our dedicated staff bring expertise, commitment, and heart to every initiative.
            </h6>
          </div>

          <div className="row justify-content-center">
            {staffMembers.map((staff, idx) => (
              <OneStaff
                key={idx}
                passport={staff.passport}
                name={staff.name}
                position={staff.position}
                intro={staff.intro}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
